var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.pricesCount > 0
    ? _c(_setup.InfoCard, {
        attrs: {
          subtitle: `${_setup.numberFormatter.format(
            _setup.pricesCount
          )} ${_setup.tStatic("цены на услуги")}`,
          icon: "ui-icon-ruble1",
        },
        on: { click: _setup.handleClickPrices },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }